<template>
  <div data-v-d27b4d60="" data-v-e5781868="" class="myAccount mainContent top50">
    <div data-v-d27b4d60="" class="content">
      <div data-v-d27b4d60="" class="top zeroLevel">
        <div data-v-d27b4d60="" class="box" style="width: 100%; background-image: url('https://91a2c0front.vzyvv.com/cdn/91a2c0FNEW/static/img/normal-1.2721da08.png')">
          <div data-v-d27b4d60="" class="box-inner">
            <div data-v-d27b4d60="" class="username">
              <div data-v-d27b4d60="" class="text">
                尊敬的 <span data-v-d27b4d60="" style="margin-left: 5px">{{ $store.state.userInfo.username }}</span>
              </div>
            </div>
            <div data-v-d27b4d60="" class="bottom-section">
              <div data-v-d27b4d60="" class="group">
                <div data-v-d27b4d60="" class="inputGroup">
                  <label data-v-d27b4d60="">CNY账户</label>
                  <input data-v-d27b4d60="" type="text" :value="$store.state.userInfo.balance" disabled />
                  <span data-v-d27b4d60="" class="current"
                    ><svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon greenDot">
                      <use data-v-338e1447="" xlink:href="#icon-greenDot"></use>
                    </svg>
                    使用中
                  </span>
                </div>
                <div data-v-d27b4d60="" class="help">
                  <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon iconHelp">
                    <use data-v-338e1447="" xlink:href="#icon-iconHelp"></use>
                  </svg>
                  <div data-v-d27b4d60="" class="message">请选择一种资产进行游戏</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-d27b4d60="" class="nav">
        <ul data-v-d27b4d60="">
          <a href="javascript:void(0);" @click="$parent.goNav('/accountSetting')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconSetting">
                <use data-v-338e1447="" xlink:href="#icon-iconSetting"></use>
              </svg>
              账户设置
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/myWallet')">
            <li data-v-d27b4d60="" class="active">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconWallet">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              我的钱包
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/transfer')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconWallet">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              转账
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/fundingRecords')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconRecord">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              资金记录
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/activityRecord')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconRecord">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              活动及代理
            </li>
          </a>
        </ul>
      </div>

      <div data-v-1eba2a24="" data-v-d27b4d60="" class="myWallet">
        <div data-v-1eba2a24="" class="topTxt">
          <div data-v-1eba2a24="" class="item">
            <h1 data-v-1eba2a24="">银行卡</h1>
            <div data-v-1eba2a24="" class="divider"></div>
            <p data-v-1eba2a24="">若需修改银行卡信息，可删除该银行卡重新添加即可，最多可添加5张</p>
          </div>
          <div data-v-1eba2a24="" class="item"></div>
        </div>
        <div data-v-1eba2a24="" class="bankcardList">
          <div data-v-3917b340="" class="box bg2" v-for="(item, index) in cardLis" :key="index">
            <svg data-v-338e1447="" data-v-3917b340="" aria-hidden="true" class="svg-icon delete"><use data-v-338e1447="" xlink:href="#icon-myWalletDelete"></use></svg>
            <div data-v-3917b340="" class="txt">
              <div data-v-3917b340="" class="cardName">
                <!-- <svg data-v-338e1447="" data-v-3917b340="" aria-hidden="true" class="bankIcon svg-icon icbc">
                  <use data-v-338e1447="" xlink:href="#icon-icbc"></use>
                  </svg> -->
                <img class="bankIcon svg-icon icbc" style="width: 23px; margin-right: 6px" :src="item.ico" alt="" />

                <span data-v-3917b340="" style="margin-right: 20px">{{ item.bank }}</span> {{ item.bank_owner }}
              </div>
              <div data-v-3917b340="" class="type" @click="delShow(item)" style="cursor: pointer">解绑</div>
            </div>
            <div data-v-3917b340="" class="txt">
              <div data-v-3917b340="" class="cardNum">{{ item.bank_no }}</div>
            </div>
          </div>
          <a @click="changAddShow" v-if="cardLis.length < 5">
            <div data-v-1eba2a24="" class="box default">
              <div data-v-1eba2a24="" class="txt">
                <svg data-v-338e1447="" data-v-1eba2a24="" aria-hidden="true" class="svg-icon add">
                  <use data-v-338e1447="" xlink:href="#icon-add"></use></svg
                ><b data-v-1eba2a24="">添加银行卡</b>
              </div>
            </div>
          </a>
        </div>
        <div data-v-1eba2a24="" class="topTxt" style="margin-top: 20px">
          <div data-v-1eba2a24="" class="item">
            <h1 data-v-1eba2a24="">USDT</h1>
            <div data-v-1eba2a24="" class="divider"></div>
            <p data-v-1eba2a24="">若需修改USDT信息，可删除该USDT重新添加即可，最多可添加5张</p>
          </div>
          <div data-v-1eba2a24="" class="item"></div>
        </div>
        <div data-v-1eba2a24="" class="bankcardList">
          <div data-v-3917b340="" class="box bg2" v-for="(item, index) in usdssLis" :key="index">
            <svg data-v-338e1447="" data-v-3917b340="" aria-hidden="true" class="svg-icon delete"><use data-v-338e1447="" xlink:href="#icon-myWalletDelete"></use></svg>
            <div data-v-3917b340="" class="txt">
              <div data-v-3917b340="" class="cardName">
                <!-- <svg data-v-338e1447="" data-v-3917b340="" aria-hidden="true" class="bankIcon svg-icon icbc">
                  <use data-v-338e1447="" xlink:href="#icon-icbc"></use>
                  </svg> -->
                <span style="width: 23px; margin-right: 6px"></span>

                <span data-v-3917b340="" style="margin-right: 20px"></span> {{ item.bank_owner }}
              </div>
              <div data-v-3917b340="" class="type" @click="delShow(item)" style="cursor: pointer">解绑</div>
            </div>
            <div data-v-3917b340="" class="txt">
              <div data-v-3917b340="" class="cardNum">{{ item.bank_no }}</div>
            </div>
          </div>
          <a @click="changAddShowUsdt" v-if="usdssLis.length < 5">
            <div data-v-1eba2a24="" class="box default">
              <div data-v-1eba2a24="" class="txt">
                <svg data-v-338e1447="" data-v-1eba2a24="" aria-hidden="true" class="svg-icon add">
                  <use data-v-338e1447="" xlink:href="#icon-add"></use></svg
                ><b data-v-1eba2a24="">添加USDT地址</b>
              </div>
            </div>
          </a>
        </div>
        <!--添加USDT地址-->

        <div data-v-226bc1a2="" data-v-1eba2a24="" v-if="showUsdt" class="mask addBankCardDialog backdrop">
          <div data-v-226bc1a2="" class="popup pop1">
            <span data-v-226bc1a2="" class="close" @click="changAddShowUsdt"></span>
            <div data-v-226bc1a2="" class="titlebar">添加USDT地址</div>
            <div data-v-226bc1a2="" class="form">
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box dropbank" @click="openBank">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconCard1">
                      <use data-v-338e1447="" xlink:href="#icon-iconCard1"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" v-model="meyXi" disabled placeholder="请选择协议" class="form-input form-input2" />
                  <div data-v-226bc1a2="" class="icon">
                    <img
                      data-v-226bc1a2=""
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMWZmNzA2NS04OWJmLTRjYjItODdmZS03ZTQ4YmFlOTBkNDAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTRBRTM0RTNGMUFDMTFFNkFGQzhGNjUxQ0Y5Qjc5RTEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTRBRTM0RTJGMUFDMTFFNkFGQzhGNjUxQ0Y5Qjc5RTEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpiOWJiYTMwNi02NzY2LTRjZTgtOTAwOS03Zjc2OTM0NTEyNTQiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo4NWViOTEwZi0yM2RiLTExN2EtOGQ5My1jZTY0N2FjZDJlZDkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5GQ7trAAAAaklEQVR42mJsamqaw8DAkMxAGMxlAhLZQHyGgEKQfDZI8U8gDgbi1zgUvobK/2SCCjwC4kgg/oumEMSPhsozMCFJ7AXiKjTFIP5uGIcJTbIbiNdC2WuhfDhgQVP8H4iTgJgZSv9HlgQIMAAvsRYhT0B6LgAAAABJRU5ErkJggg=="
                      alt=""
                      class="icon-arrow"
                    />
                  </div>
                  <div data-v-226bc1a2="" class="dropDown"  v-if="bankShow">
                    <div data-v-226bc1a2="" class="dropDownList">
                      <ul data-v-226bc1a2="" class="bankList">
                        <li data-v-226bc1a2="" @click="changmeyXi('ERC20')">
                          <span>ERC20</span>
                        </li>
                        <li data-v-226bc1a2="" @click="changmeyXi('TRC20')">
                          <span>TRC20</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div data-v-226bc1a2="" class="errorTxt"></div>
              </div>

              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconPin">
                      <use data-v-338e1447="" xlink:href="#icon-iconPin"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" placeholder="请输入USDT地址" oninput="value=value.replace(/[\W]/g,'')"  v-model="usdss" class="form-input form-input2" />
                </div>
                <div data-v-226bc1a2="" class="errorTxt" style="display: none"></div>
              </div>
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconPin">
                      <use data-v-93652822="" data-v-338e1447="" xlink:href="#icon-iconPopPassword"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" type="password" placeholder="请输入支付密码" v-model="pay_pass" class="form-input form-input2" />
                </div>
                <div data-v-226bc1a2="" class="errorTxt" style="display: none"></div>
              </div>
            </div>
            <div data-v-226bc1a2="" class="button"><span data-v-226bc1a2="" @click="bindUsdss" class="btn">确定</span></div>
          </div>
        </div>
        <!--添加银行卡-->
        <div data-v-226bc1a2="" data-v-1eba2a24="" v-if="addShow" class="mask addBankCardDialog backdrop">
          <div data-v-226bc1a2="" class="popup pop1">
            <span data-v-226bc1a2="" class="close" @click="changAddShow"></span>
            <div data-v-226bc1a2="" class="titlebar">添加银行卡</div>
            <div data-v-226bc1a2="" class="form">
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box dropbank" @click="openBank">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconCard1">
                      <use data-v-338e1447="" xlink:href="#icon-iconCard1"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" v-model="bank" placeholder="请选择银行名称" class="form-input form-input2" id="bank" />
                  <div data-v-226bc1a2="" class="icon">
                    <img
                      data-v-226bc1a2=""
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMWZmNzA2NS04OWJmLTRjYjItODdmZS03ZTQ4YmFlOTBkNDAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTRBRTM0RTNGMUFDMTFFNkFGQzhGNjUxQ0Y5Qjc5RTEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTRBRTM0RTJGMUFDMTFFNkFGQzhGNjUxQ0Y5Qjc5RTEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpiOWJiYTMwNi02NzY2LTRjZTgtOTAwOS03Zjc2OTM0NTEyNTQiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo4NWViOTEwZi0yM2RiLTExN2EtOGQ5My1jZTY0N2FjZDJlZDkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5GQ7trAAAAaklEQVR42mJsamqaw8DAkMxAGMxlAhLZQHyGgEKQfDZI8U8gDgbi1zgUvobK/2SCCjwC4kgg/oumEMSPhsozMCFJ7AXiKjTFIP5uGIcJTbIbiNdC2WuhfDhgQVP8H4iTgJgZSv9HlgQIMAAvsRYhT0B6LgAAAABJRU5ErkJggg=="
                      alt=""
                      class="icon-arrow"
                    />
                  </div>
                  <div data-v-226bc1a2="" class="dropDown" v-if="bankShow">
                    <div data-v-226bc1a2="" class="dropDownList">
                      <h1 data-v-226bc1a2="">{{$store.state.appInfo.title}}推荐的银行-支持2小时内到账 <span data-v-226bc1a2="">推荐</span></h1>
                      <ul data-v-226bc1a2="" class="bankList">
                        <li data-v-226bc1a2="" v-for="(item, index) in banklist" :key="index" @click="changBank(item.bank_name)">
                          <img class="bankIcon svg-icon icbc" style="width: 15px; margin-right: 6px" :src="baseURL + item.ico" alt="" />

                          <span>{{ item.bank_name }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div data-v-226bc1a2="" class="errorTxt"></div>
              </div>
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon user">
                      <use data-v-338e1447="" xlink:href="#icon-user"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" class="form-input form-input2" placeholder="请输入姓名" v-model="bank_owner" />
                </div>
                <div data-v-226bc1a2="" class="errorTxt"></div>
              </div>
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconCard2">
                      <use data-v-338e1447="" xlink:href="#icon-iconCard2"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" placeholder="请输入您的银行卡号" oninput="value=value.replace(/[^0-9]/g,'')" v-model="bank_no" class="form-input form-input2" />
                </div>
                <div data-v-226bc1a2="" class="errorTxt"></div>
              </div>
              <!-- <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconCard3">
                      <use data-v-338e1447="" xlink:href="#icon-iconCard3"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" placeholder="请再次输入您的银行卡号" class="form-input form-input2" />
                </div>
                <div data-v-226bc1a2="" class="errorTxt"></div>
              </div> -->
              <!-- <div data-v-226bc1a2="" class="item span2">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconPin">
                      <use data-v-338e1447="" xlink:href="#icon-iconPin"></use>
                    </svg>
                  </div>
                  <select class="province" name="province" id="param_province" onchange="provincechange()" style="width: 100%; height: 100%; border: 0; font-size: 14px; color: #333; width: 100%; padding-left: 0.15rem; outline: 0">
                    <option value="请选择省份">请选择省份</option>
                    
                  </select>
                </div>
                <div data-v-226bc1a2="" class="box">
                  <select class="city" name="city" id="param_city" style="width: 100%; height: 100%; border: 0; font-size: 14px; color: #333; width: 100%; padding-left: 0.15rem; outline: 0">
                    <option>请选择城市</option>
                  </select>
                </div>
                <div data-v-226bc1a2="" class="errorTxt" style="display: none"></div>
                <div data-v-226bc1a2="" class="errorTxt" style="display: none"></div>
              </div> -->
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconPin">
                      <use data-v-338e1447="" xlink:href="#icon-iconPin"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" placeholder="请输入开户行网点" v-model="bank_address" class="form-input form-input2" />
                </div>
                <div data-v-226bc1a2="" class="errorTxt" style="display: none"></div>
              </div>
              <div data-v-226bc1a2="" class="item">
                <div data-v-226bc1a2="" class="box">
                  <div data-v-226bc1a2="" class="icon">
                    <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconPin">
                      <use data-v-93652822="" data-v-338e1447="" xlink:href="#icon-iconPopPassword"></use>
                    </svg>
                  </div>
                  <input data-v-226bc1a2="" placeholder="请输入支付密码" v-model="pay_pass" class="form-input form-input2" />
                </div>
                <div data-v-226bc1a2="" class="errorTxt" style="display: none"></div>
              </div>
            </div>
            <div data-v-226bc1a2="" class="button"><span data-v-226bc1a2="" @click="bindCard" class="btn">确定</span></div>
          </div>
        </div>
        <!-- 删除银行卡 -->
        <div data-v-68239ec0="" class="mask setmobile" v-if="delBox.id">
          <div data-v-6146fa75="" data-v-68239ec0="" class="content">
            <div data-v-6146fa75="" class="backdrop">
              <div data-v-6146fa75="" class="popup popup2">
                <div data-v-6146fa75="" class="popHead">
                  确定要删除吗?
                  <a data-v-6146fa75="" class="popClose" @click="closeDel"
                    ><svg data-v-338e1447="" data-v-6146fa75="" aria-hidden="true" class="svg-icon iconClose">
                      <use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg
                  ></a>
                </div>
                <div data-v-6146fa75="" class="popContent">
                  <form data-v-6146fa75="">
                    <div data-v-6146fa75="" class="warning message">
                      <svg data-v-338e1447="" data-v-6146fa75="" aria-hidden="true" class="svg-icon iconWarning">
                        <use data-v-338e1447="" xlink:href="#icon-iconWarning"></use>
                      </svg>
                      解绑{{ delBox.bank_no }}-{{ delBox.bank_owner }}
                    </div>

                    <div data-v-6146fa75="" class="popBtn buttonSolid" @click="isDelOk()">确定</div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'myWallet',
  data() {
    return {
      addShow: false,
      bankShow: false,
      banklist: [],
      delBox: {},
      baseURL: '',
      bank: null,
      bank_owner: null,
      pay_pass: null,
      bank_no: null,
      bank_address: null,
      cardLis: [],
      usdssLis: [],
      meyXi: 'ERC20', //qian
      showUsdt: false,
      usdss: '',
    };
  },
  created() {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    that.getcard();
    that.getUsdssList();
    that.getBanklist();
  },
  methods: {
    changmeyXi(val) {
      this.meyXi = val;
    },
    getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },
    delShow(item) {
      let that = this;
      that.delBox = item;
    },
    closeDel() {
      let that = this;
      that.delBox = {};
    },
    isDelOk() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/delcard', { id: that.delBox.id }).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.$parent.showTost(1, '解绑成功');
          that.delBox = {};

          that.getcard();
          that.getUsdssList();
          
        }
        that.$parent.hideLoading();
      });
    },
    bindCard() {
      let that = this;
      if (!that.bank_owner) {
        that.$parent.showTost(0, '请输入姓名');
        return;
      }
      if (!that.bank) {
        that.$parent.showTost(0, '请输入银行');
        return;
      }
      if (!that.bank_address) {
        that.$parent.showTost(0, '请输入开户行地址');
        return;
      }
      if (!that.bank_no) {
        that.$parent.showTost(0, '请输入银行卡号');
        return;
      }
      if (!that.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      if (that.bank_no.length < 8) {
        that.$parent.showTost(0, '请输入正确的卡号长度');
        return;
      }
      if (that.pay_pass.length < 6 || that.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输入支付密码长度');
        return;
      }
      that.$parent.showLoading();
      let info = { bank_owner: that.bank_owner, bank: that.bank, bank_address: that.bank_address, bank_no: that.bank_no, pay_pass: that.pay_pass };
      that.$apiFun
        .post('/api/bindcard', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
            that.getcard();
            that.changAddShow();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getBanklist() {
      let that = this;
      that.$apiFun.post('/api/banklist', {}).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.banklist = res.data;
        }
      });
    },
    openBank() {
      this.bankShow = !this.bankShow;
    },
    getcard() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getcard', { type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changAddShow() {
      let that = this;
      that.bank_owner = null;
      that.bank = null;
      that.bank_address = null;
      that.bank_no = null;
      that.pay_pass = null;
      if (this.addShow == false && that.cardLis.length >= 5) {
        that.$parent.showTost(0, '最多添加5张银行卡');
        return;
      }
      this.addShow = !this.addShow;
    },
    changAddShowUsdt() {
      let that = this;
      that.bank_owner = null;
      that.bank = null;
      that.bank_address = null;
      that.bank_no = null;
      that.pay_pass = null;
      if (this.addShow == false && that.cardLis.length >= 5) {
        that.$parent.showTost(0, '最多添加5张银行卡');
        return;
      }
      this.showUsdt = !this.showUsdt;
    },
    bindUsdss() {
      let that = this;
      let usdss = that.usdss;
      let meyXi = that.meyXi;

      if (usdss == null || usdss == '') {
        that.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!meyXi) {
        that.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!that.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', { bank: 'USDT', bank_no: usdss, bank_owner: meyXi, pay_pass: that.pay_pass })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '添加成功！');
            that.getUsdssList();
            that.changAddShowUsdt();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    //弹出登录框
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    //弹出注册框
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    //弹出忘记密码框
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
    changBank(bank) {
      let that = this;
      that.bank = bank;
    },
  },
  mounted() {
    let that = this;
    //首页banner
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    //首页时间轴品牌历程
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    //盈利榜
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });

    // 弹出银行下拉
    // $('.dropbank').click(function () {
    //   $(this).find('.dropDown').toggle();
    // });
    // 选择银行
    // $('.bankList li').click(function () {
    //   var bankName = $(this).find('span').text();
    //   $('#bank').val(bankName);
    // });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-06254e6a.f0cc50a1.css';
@import '../../../static/css/chunk-645a6edf.25ca78d5.css';
@import '../../../static/css/chunk-4344ad92.cf88b5c7.css';
@import '../../../static/css/chunk-970915c0.1e5ddf77.css';

.myWallet .bankcardList .box.bg2[data-v-3917b340] {
  background: url(/static/image/bg2.c14d2591.png) no-repeat;
  background-size: 100% 100%;
  border: 1px solid #1f2026;
}
.myWallet .bankcardList .box .mask[data-v-3917b340],
.myWallet .bankcardList .box[data-v-3917b340] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.myWallet .bankcardList .box[data-v-3917b340] {
  background: #191a1f;
  border: 1px dashed #5b5f67;
  border-radius: 0.08rem;
  border-radius: 8px;
  width: 4.09rem;
  height: 1.5rem;
  margin-bottom: 0.2rem;
  margin-right: 4px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.myWallet .bankcardList .box .delete[data-v-3917b340] {
  display: none;
  position: absolute;
  width: 0.34rem;
  height: 0.34rem;
  top: 0.01rem;
  right: 0.01rem;
  cursor: pointer;
}

.svg-icon[data-v-338e1447] {
  width: 10em;
  height: 10em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.myWallet .bankcardList .box .txt .cardName[data-v-3917b340],
.myWallet .bankcardList .box .txt[data-v-3917b340] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.myWallet .bankcardList .box .txt[data-v-3917b340] {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  margin-bottom: 0.3rem;
}
.myWallet .bankcardList .box .txt .cardName[data-v-3917b340] {
  font-size: 0.2rem;
  color: #fff;
  letter-spacing: 0;
  text-align: left;
}

.myWallet .bankcardList .box .txt .cardName[data-v-3917b340],
.myWallet .bankcardList .box .txt[data-v-3917b340] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.myWallet .bankcardList .bankIcon[data-v-3917b340] {
  display: inline-block;
  margin-right: 0.15rem;
  width: 0.24rem;
  height: 0.24rem;
}

.svg-icon[data-v-338e1447] {
  width: 10em;
  height: 10em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.myWallet .bankcardList .box .txt[data-v-3917b340]:last-child {
  margin-bottom: 0;
}

.myWallet .bankcardList .box .txt .cardName[data-v-3917b340],
.myWallet .bankcardList .box .txt[data-v-3917b340] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.myWallet .bankcardList .box .txt[data-v-3917b340] {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  margin-bottom: 0.3rem;
}
.myWallet .bankcardList .box .txt .cardNum[data-v-3917b340] {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.3rem;
  color: #fff;
  letter-spacing: 0;
}
.myWallet .bankcardList .box .txt .type[data-v-3917b340] {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  padding: 0 0.04rem;
  height: 0.22rem;
  background-image: linear-gradient(135deg, #424242, #000);
  border-radius: 0.02rem;
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #f9cb5c;
  letter-spacing: 0;
  text-align: right;
  line-height: 0.18rem;
  font-weight: 400;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/myWallet.vue